import React from "react";

import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
    versionString: {
        margin: "5px",
        fontSize: "0.8em",
        color: "gray",
        justifySelf: "end",
    },
});
export function DatasetVersionStringForList({
    className,
    datasetType,
    version,
}: {
    className?: string;
    datasetType: string;
    version: string;
}): JSX.Element {
    const classes = useStyles();
    return (
        <div className={`${classes.versionString} ${className || ""}`}>
            {datasetType} dataset version: <b>{version}</b>
        </div>
    );
}
